<template>
  <div class="project-box org-container scroll_bar_beautify_ff">
    <div
      v-if="datasReady"
      class="manage-list-tab org-main"
      :class="[`${projectType}-project`]"
    >
      <!-- 隐藏关闭的项目 -->
      <div
        class="change-list-btn"
        :class="{'change-list-btn2': $isDingDing || !isTabShow }"
      >
        <a-checkbox
          v-if="datas.mc || datas.xp || datas.realback"
          :default-checked="ishidden"
          @change="filterPro"
        >
          {{ $t('message["1491"]') }}
        </a-checkbox>
      </div>
      <project-list
        v-if="$isDingDing || !isTabShow"
        :data="oneTabList"
      />
      <a-tabs
        v-else
        v-model="activeName"
        :animated="false"
        @change="handleClick"
      >
        <a-tab-pane
          v-if="datas.xp"
          key="inquery"
          tab="询盘管理"
        >
          <project-list
            :data="datas.list['xp'] || []"
          />
        </a-tab-pane>
        <a-tab-pane
          v-if="datas.mc"
          key="member"
          tab="会员管理"
        >
          <project-list
            :data="datas.list['mc'] || []"
          />
        </a-tab-pane>
        <a-tab-pane
          v-if="datas.realback"
          key="realback"
          tab="广告回传"
        >
          <project-list
            :data="datas.list['realback'] || []"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { setStorage } from '@/lib/storage'
import ProjectList from './index/ProjectList'

export default {
  name: 'ProjectIndex',
  components: {
    ProjectList
  },
  data () {
    return {
      activeName: 'inquery',
      oneTabList: [] // tab只有一个时直接展示内容
    }
  },
  computed: {
    ...mapState('organization/org', ['datasReady', 'datas', 'projectType']),
    ishidden () {
      const { 'is_hide_close_pro': isHide } = this.$store.state.baseinfo
      return isHide === 1
    },
    cid () {
      return this.$route.query.cid
    },
    tabLength () {
      const { list = {} } = this.datas
      return Object.keys(list).length
    },
    isTabShow () {
      return this.tabLength > 1
    }
  },
  async created () {
    const _this = this
    const { cid = '' } = this
    if (cid) {
      const chain2 = await this.fetchOrgDetail({ cid })
      chain2.fetch()
    }
    const chain = await this.fetchProjectList({ cid })
    chain
      .onSuccess(raw => {
        const defaultType = this.setType(raw)
        this.setProjectType(defaultType)
        // this.$set(this.$route.query, 'type', defaultType)
        this.$router.push({
          query: {
            ...this.$route.query,
            type: defaultType
          }
        })
        this.activeName = defaultType
        const isManage = !!raw.isadmin || !!raw.isfounder
        this.setIsManage(isManage)

        const { xp, mc, realback, list = {} } = _this.datas || {}
        if (_this.tabLength && this.$isDingDing) {
          this.oneTabList = list['xp']
        } else if (_this.tabLength === 1 && xp) {
          this.oneTabList = list['xp']
        } else if (_this.tabLength === 1 && mc) {
          this.oneTabList = list['mc']
        } else if (_this.tabLength === 1 && realback) {
          this.oneTabList = list['realback']
        }

        setStorage('realbackCid', (raw && raw.cid) || '')
      })
      .fetch()
  },
  methods: {
    ...mapActions('organization/org', ['fetchProjectList', 'fetchOrgDetail']),
    ...mapMutations('organization/org', ['setProjectType']),
    ...mapMutations(['setIsManage']),
    handleClick (tab, event) {
      this.triggerTab(tab)
    },
    async filterPro (e) {
      let ishidden = e.target.checked ? 1 : 0
      const chain = await this.fetchProjectList()
      chain
        .params({ cid: this.cid, ishidden: ishidden })
        .fetch()
    },
    triggerTab (type) {
      this.setProjectType(type)
      this.$router.push({
        name: 'ProjectIndexPc',
        query: {
          cid: this.cid,
          type
        }
      })
    },
    setType (data) {
      let { type = '' } = this.$route.query
      let projectType = 'inquery'
      const { mc = true, xp = true, realback = true, list = {} } = data

      let tabLength = this.tabLength
      if (type === 'inquery' && xp) {
        projectType = 'inquery'
      } else if ((type === 'member' && mc) || (tabLength === 1 && mc)) {
        projectType = 'member'
      } else if ((type === 'realback' && realback) || (tabLength === 1 && realback)) {
        projectType = 'realback'
      } else if (((type === 'inquery' && !xp) || (type === 'member' && !mc) || (type === 'realback' && !realback) || !type) && tabLength) {
        // 如果链接type值不存在于接口返回值list，自动跳转到可以访问的第一个类型
        const k = Object.keys(list)[0]
        if (k === 'mc') {
          projectType = 'member'
        } else if (k === 'xp') {
          projectType = 'inquery'
        } else if (k === 'realback') {
          projectType = 'realback'
        }
      } else {
        projectType = 'inquery'
      }
      return projectType
    }
  }
}
</script>
<style lang="scss" scoped>
.project-box::v-deep{
  padding: 24px 40px;
  .member-project,
  .inqury-project,
  .realback-project {
    .project-item {
      position: relative;
      &::after{
        position: absolute;
        background: url(../../assets/images/promcico.png) no-repeat 0 0;
        width: 81px;
        height: 80px;
        background-size: 81px 80px;
        content: '';
        bottom: 24px;
        right: 48px;
      }
    }
  }
  .inqury-project .project-item::after {
    background: url(../../assets/images/proinquryico.png) no-repeat 0 0;
    background-size: 81px 80px;
  }
  .ant-tabs {
    overflow:visible !important;
  }
  .manage-list-tit {
    padding: 0 0 24px;
    font-size: 32px;
    font-weight: bold;
    h2{
      font-weight: 600;
    }
  }
  .ant-tabs-tab {
    font-size: 18px;
    padding: 12px 0;
  }
  .ant-tabs-bar{
    border-bottom: none;
  }
  .change-list-btn {
    position: absolute;
    right: 40px;
    top: 40px;
    .ant-checkbox-wrapper {
      margin-right: 0;
    }
  }
  .change-list-btn2 {
    position: static !important;
    line-height: 32px;
  }
}
</style>
